import { render, staticRenderFns } from "./ThgQuoteUpdateRegistrationImageDialog.vue?vue&type=template&id=dbe94488"
import script from "./ThgQuoteUpdateRegistrationImageDialog.vue?vue&type=script&lang=ts"
export * from "./ThgQuoteUpdateRegistrationImageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports